import React from 'react';
import { useEffect, useState } from "react";
import apiAdm from "../../../services/apiAdm.js";
import apiAcbr from "../../../services/apiAcbr.js";
import DataTable from "react-data-table-component";
import '../../../style/global.css';
import { FiPrinter, FiDownloadCloud, FiRefreshCcw, FiInfo, FiDownload, FiFileText, FiMoreVertical, FiFilter } from "react-icons/fi";
import { SweetAlertSuccess, SweetAlertError, SweetAlertConfirm } from '../../../components/sweetAlert/swetAlert.jsx';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';


function NFeEntrada() {

  const [pageSize, setPageSize] = useState(10);
  const [dados, setDados] = useState([]);

  const [idEntidade, setEntidade] = useState(localStorage.getItem('idEmpresa'));
  const [EditaId, setEditaId] = useState(0);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [loading, setLoading] = useState(false);

  //Filtro
  const [status, setStatus] = useState([]);
  const [idStatus, setIDStatus] = useState([]);
  const [manifestos, setManifestos] = useState([]);
  const [idManifesto, setIDManifesto] = useState([]);
  const [nomeDestina, setNomeDestina] = useState('');
  const [valorDe, setValorDe] = useState('');
  const [valorAte, setValorAte] = useState('');
  const [dataDe, setDataDe] = useState('');
  const [dataAte, setDataAte] = useState('');
  const [numeroNota, setNumeroNota] = useState('');
  const [chave, setChave] = useState('');

  const [showModalSefaz, setShowModalSefaz] = useState(false);
  const [showModalMaisInfo, setShowModalMaisInfo] = useState(false);
  const [showModalChave, setShowModalChave] = useState(false);
  const [showModaResultadoConsulta, setShowModaResultadoConsulta] = useState(false);
  const [showModaResultadoManifesto, setShowModaResultadoManifesto] = useState(false);
  const [showModalJustificativa, setShowModalJustificativa] = useState(false);

  const [infoID, setInfoID] = useState('');
  const [infoDestina, setInfoDestina] = useState('');
  const [infoChave, setInfoChave] = useState('');

  const [chNFe, setChNFe] = useState('');
  const [justificativa, setJustificativa] = useState('');

  const [qtdCCe, setQtdCCe] = useState(0);
  const [qtdCancelada, setQtdCancelada] = useState(0);
  const [qtdNota, setQtdNota] = useState(0);

  const [dadosManifesto, setDadosManifesto] = useState([]);
  const [dadosEventos, setDadosEventos] = useState([]);

  const tableCustomStyles = {
    headRow: {
      style: {
        color: 'white',
        backgroundColor: '#6571ff'
      },
    },

  };

  const [seletectRows, setSelectedRows] = useState([]);

  const handleSelectedRowsChange = (rows) => {
    setSelectedRows(rows.selectedRows);
  };

  const columns = [
    // {
    //   // name: '',
    //   cell: row => {
    //     <input type='checkbox' value={row.id} inputProps={{ 'aria-label': 'primary checkbox' }} />
    //   },
    //   width: "1%",
    // },

    {
      name: 'Status',
      cell: row =>
        <>
          {row.idStatus == 4 ?
            <span className="badge bg-danger">{row.statusNome}</span> :
            <span className="badge bg-success">{row.statusNome}</span>}
        </>,
      sortable: true,
      width: "8%",
    },
    {
      name: 'Manifesto',
      cell: row =>
        <>
          {(row.idManifesto == 0 || row.idManifesto == 3) ?
            <span className="badge bg-secondary">{row.manifestoNome}</span> :
            <span className="badge bg-success">{row.manifestoNome}</span>}
        </>,

      sortable: true,
      compact: true,
      width: "9%",
    },
    {
      name: 'Fornecedor',
      selector: row => row.nome,
      sortable: true,
      width: "30%",
    },
    {
      name: 'Emissão',
      selector: row => row.dhEmi,
      sortable: true,
      wrap: true,

      width: "10%",
      format: row => new Intl.DateTimeFormat('pt-BR',
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        }).format(new Date(row.dhEmi)),
      center: true
    },
    {
      name: 'Valor',
      selector: row => row.vNF,
      sortable: true,
      right: true,
      width: "12%",
      format: row => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(row.vNF)
    },
    {
      name: 'Numero',
      selector: row => row.nNF,
      sortable: true,
      width: "9%",
    },
    {
      name: 'CCe',
      cell: row =>
        <>
          {(row.cceChave !== null) ?
            <button onClick={() => ImprimirCCe(row.id, row.cceChave, row.chave)} style={{ height: '26px', width: '26px' }} className='btn btn-sm btn-icon btn-outline-primary rounded-circle mr-2' title='Imprimir CCe'>
              <FiFileText /></button> : null}
        </>,
      width: "6%",
    },

    {
      name: 'Ações',
       cell: (row) => <>
  
        <button type="button" style={{ height: '26px', width: '26px',  position: 'relative', zIndex: 10  }} className='btn btn-sm btn-icon btn-outline-primary rounded-circle mr-2'
          data-bs-toggle="dropdown"
           aria-haspopup="true" aria-expanded="false"
        >

          <FiMoreVertical />
        </button>
        <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
          <a onClick={() => Danfe(row.id, row.idManifesto)} className="dropdown-item"
            href="#">Imprimir Danfe</a>
          <a onClick={() => downloadXML(row.id, row.idManifesto)} className="dropdown-item"
            href="#">Download xml</a>
          <a onClick={() => atualizarChave(row.id)} className="dropdown-item"
            href="#">Atualizar chave de acesso</a>
          <a onClick={() => maisInfo(row.id, row.nome, row.chave)} className="dropdown-item"
            href="#">Mais informações</a>
        </div>

      </>,

      // cell: (row) => <>
      //   <button onClick={() => Danfe(row.id)} style={{ height: '26px', width: '26px' }} className='btn btn-sm btn-icon btn-outline-primary rounded-circle mr-2' title='Imprimir danfe'>
      //     <FiPrinter /></button>
      //   <button onClick={() => downloadXML(row.id)} style={{ height: '26px', width: '26px' }} className='btn btn-sm btn-icon btn-outline-primary rounded-circle mr-2' title='Download xml'>
      //     <FiDownloadCloud /></button>
      //   <button onClick={() => atualizarChave(row.id)} style={{ height: '26px', width: '26px' }} className='btn btn-sm btn-icon btn-outline-primary rounded-circle mr-12' title='Download xml'>
      //     <FiRefreshCcw /></button>
      //   <button onClick={() => maisInfo(row.id)} style={{ height: '26px', width: '26px' }} className='btn btn-sm btn-icon btn-outline-primary rounded-circle mr-2' title='Mais informações...'>
      //     <FiInfo /></button>

      // </>,

      width: "8%",        // width: "150px",
      center: true
    }
  ];


  const colEventos = [
    {
      name: 'Evento',
      selector: row => row.eventoNome,
      sortable: true,
      width: '30%'
    },
    {
      name: 'Protocolo',
      selector: row => row.nProt,
      sortable: true,
      width: '20%'
    },
    {
      name: 'Data do evento',
      selector: row => row.dhEvento,
      sortable: true,
      width: '20%',
      format: row => new Intl.DateTimeFormat('pt-BR',
        {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        }).format(new Date(row.dhEvento)),
      center: true

    },
  ];

  const colManifesto = [
    {
      name: 'Chave de acesso',
      selector: row => row.chDFe,
      sortable: true,
      width: "40%",
    },
    {
      name: 'Status',
      cell: row =>
        <>
          {row.cStat == 135 ?
            <span className="text-success">{row.cStat + ' - ' + row.xMotivo}</span> :
            <span className="text-danger">{row.cStat + ' - ' + row.xMotivo}</span>}
        </>,
      // selector: row => row.cStat + ' - ' + row.xMotivo,
      sortable: true,
      width: "50%",
    },
  ];

  const paginationOptions = {
    rowsPerPageText: 'Registros por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: false,
    selectAllRowsItemText: 'Todos'
  };

  function Listar(pageSize, page) {
    setValorAte(valorDe);

    const tipo = 'E';
    const xmlTipo = 1;
    setLoading(true);
    apiAdm.get("/xmlresumo",
      {
        params: {
          idEntidade, tipo, xmlTipo, idStatus, idManifesto, nomeDestina,
          dataDe, dataAte, valorDe, valorAte, numeroNota, chave, page, pageSize
        }
      }
    )
      .then((resp) => {
        console.log(resp.data);
        setTotalRegistros(resp.data.count);
        setDados(resp.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setTotalRegistros(0);
        setDados([]);
        SweetAlertError({ texto: 'Erro ao carregar as Notas de entradas' });
      });
  }

  useEffect(() => {
    ComboStatus();
    ComboManifesto();
    Listar(pageSize, 1);
  }, []);

  function ChangePerRows(newQtd, page) {
    Listar(newQtd, page);
    setPageSize(newQtd);
  }

  function ChangePage(newPage) {
    Listar(pageSize, newPage);
  }

  function ComboStatus() {
    apiAdm.get("/statusResumo")
      .then((resp) => {
        console.log(resp.data.data);
        setStatus(resp.data.data);
      })
      .catch((err) => {
        setStatus([]);
        SweetAlertError({ texto: 'Erro ao montar Status' });
      });
  };

  function ComboManifesto() {
    apiAdm.get("/manifesto")
      .then((resp) => {
        console.log(resp.data.data);
        setManifestos(resp.data.data);
      })
      .catch((err) => {
        setManifestos([]);
        SweetAlertError({ texto: "Erro ao montar Manifesto" });
      });
  };

  function ChangeStatus(e) {
    setIDStatus(e.target.value);
  }

  function ChangeManifesto(e) {
    setIDManifesto(e.target.value);
  };

  function limparFiltro() {
    setIDStatus([]);
    setIDManifesto([]);
    setNomeDestina('');
    setValorDe('');
    setValorAte('');
    setDataDe('');
    setDataAte('');
    setNumeroNota('');
    setChave('');
  };

  function closeModalSefaz() {
    setShowModalSefaz(false);
  };

  function closeModalMaisInfo() {
    setShowModalMaisInfo(false);
  }

  function closeModalChave() {
    setShowModalChave(false);
  }


  function closeModalResultadoConsulta() {
    setShowModaResultadoConsulta(false);
  };

  function closeModalResultadoManifesto() {
    setShowModaResultadoManifesto(false);
  }

  function closeModalJustificativa() {
    setShowModalJustificativa(false);
  }

  function maisInfo(id, nome, chave) {
    let idResumo = id;
    apiAdm.get("/xmlevento",
      {
        params: {
          idResumo
        }
      }
    )
      .then((resp) => {
        console.log(resp.data);
        setDadosEventos(resp.data.data);
      })
      .catch((err) => {
        console.log(err);
        setDadosEventos([]);
        SweetAlertError({ texto: "Erro ao carregar os eventos desta nota." });
      });

    setInfoID(id);
    setInfoDestina(nome);
    setInfoChave(chave);
    setShowModalMaisInfo(true);
  };

  function modalChave() {
    setChNFe('');
    setShowModalChave(true);
  };


  //Ações
  async function Consultar() {

    setShowModalSefaz(true);
    let json = {
      idEmpresa: localStorage.getItem('idEmpresa'),
      cUF: localStorage.getItem('cUF'),
      nsu: localStorage.getItem('nsuNFe'),
      cnpj: localStorage.getItem('cnpjEmpresa'),
      certificado: {
        url: localStorage.getItem('idEmpresa') + '.pfx',
        senha: localStorage.getItem('certSenha')
      }
    };
    console.log(json);

    await apiAcbr.post('/DFe/ConsultarNFe', json)
      .then((resp) => {
        console.log(resp);
        setShowModalSefaz(false);
        setQtdNota(resp.data.qtdNota);
        setQtdCCe(resp.data.qtdCCe);
        setQtdCancelada(resp.data.qtdCancelada);
        setShowModaResultadoConsulta(true);
      })
      .catch((err) => {
        console.log('Erro: ', err.response.data);
        setShowModalSefaz(false);
        SweetAlertError({ texto: err.response.data.msg });
      });
  };

  async function ConsultarChave() {
    if (chNFe == '') {
      SweetAlertError({ texto: 'Falta informar a chave de acesso.' });
    } else {
      setShowModalSefaz(true);
      let json = {
        idEmpresa: localStorage.getItem('idEmpresa'),
        cnpj: localStorage.getItem('cnpjEmpresa'),
        cUF: localStorage.getItem('cUF'),
        certificado: {
          url: localStorage.getItem('idEmpresa') + '.pfx',
          senha: localStorage.getItem('certSenha')
        },
        chaves: [
          { chNFe: chNFe },
        ]
      };
      await apiAcbr.post('/DFe/ConsultarPorChaveNFe', json)
        .then((resp) => {
          setShowModalSefaz(false);
          SweetAlertSuccess({ texto: 'Consulta realizada com sucesso.' });
        })
        .catch((err) => {
          console.log(err);
          setShowModalSefaz(false);
          SweetAlertError({ texto: err });
        });
    };

  };

  function Ciencia() {
    Manifestar(2);
  };

  function Confirmar() {
    Manifestar(1);
  };

  function Desconhecer() {
    Manifestar(3);
  };

  function NaoRealizar() {
    setShowModalJustificativa(true);
  };

  function ManifestarNaoRealizada() {
    Manifestar(4);
  };


  async function Manifestar(tipo) {
    if (seletectRows.length == 0) {
      SweetAlertError({ texto: 'Falta selecionar a(s) nota(s).' });
      return;
    };

    if ((tipo == 4) && (justificativa == null)) {
      SweetAlertError({ texto: 'Falta informar a justificativa.' });
      return;
    };

    setShowModalSefaz(true);
    var chaves = [];
    for (var i = 0; i < seletectRows.length; i++) {
      let chave = {
        chNFe: seletectRows[i].chave
      };
      chaves.push(chave);
    };

    let json = {
      idEmpresa: localStorage.getItem('idEmpresa'),
      cnpj: localStorage.getItem('cnpjEmpresa'),
      tipoManifesto: tipo,
      cUF: localStorage.getItem('cUF'),
      xJust: justificativa,
      certificado: {
        url: localStorage.getItem('idEmpresa') + '.pfx',
        senha: localStorage.getItem('certSenha')
      },
      chaves: chaves
    };
    await apiAcbr.post('/DFe/ManifestarNFe', json)
      .then((resp) => {
        console.log(resp.data);
        Listar(pageSize, 1);
        setDadosManifesto(resp.data.chaves);
        setShowModalSefaz(false);
        setShowModaResultadoManifesto(true);
      })
      .catch((err) => {
        console.log('Erro: ', err);
        setShowModalSefaz(false);
        SweetAlertError({ texto: err.response.data.msg });
      });

  };

  async function Danfe(id, idManifesto) {

    if (idManifesto == 0) {
      SweetAlertError({ texto: 'Nota sem manifesto.' });
      return;
    }

    const popup = window.open('about:blank', '_blank');
    await apiAdm.get("/xmlresumo/" + id,
    )
      .then(async (resp) => {
        console.log(resp);
        let json = {
          status: resp.data.data.idStatus,
          chave: resp.data.data.chave,
          cnpj: localStorage.getItem('cnpjEmpresa'),
          idEmpresa: localStorage.getItem('idEmpresa'),

          casaQtda: 2,
          casaPreco: 2
        };
        await apiAcbr.post('/NFe/ImprimirNFe', json)
          .then((resp2) => {
            console.log(resp2);
            if (popup) {
              popup.location.href = resp2.data.urlPdf;
            }
            // window.open(resp2.data.urlPdf, '_blank');
          })
          .catch((err2) => {
            console.log(err2);
          })
      })
      .catch((err) => {
        SweetAlertError({ texto: 'Erro ao carregar ao imprimir o danfe. ' + err });
      });
  };

  async function downloadXML(id, idManifesto) {
    if (idManifesto == 0) {
      SweetAlertError({ texto: 'Nota sem manifesto.' });
      return;
    }

    const popup = window.open('about:blank', '_blank');
    await apiAdm.get("/xmlresumo/" + id,
    )
      .then(async (resp) => {
        let json = {
          status: resp.data.data.idStatus,
          chave: resp.data.data.chave,
          cnpj: localStorage.getItem('cnpjEmpresa'),
          idEmpresa: localStorage.getItem('idEmpresa'),
          casaQtda: 2,
          casaPreco: 2
        };
        await apiAcbr.post('/NFe/ImprimirNFe', json)
          .then((resp2) => {
            if (popup) {
              popup.location.href = resp2.data.urlXml;
            }
            // window.open(resp2.data.urlXml);
          })
          .catch((err2) => {
            console.log(err2);
          })
      })
      .catch((err) => {
        SweetAlertError({ texto: "Erro ao carregar ao imprimir o danfe. " + err });
      });

  };

  async function atualizarChave() {
  }

  async function ImprimirCCe(id, chaveCCe, chaveNFe) {
    let json = {
      'chaveXml': chaveNFe,
      'chaveCCe': chaveCCe,
      'cnpj': localStorage.getItem('cnpjEmpresa'),
      'idEmpresa': localStorage.getItem('idEmpresa')
    };
    await apiAcbr.post('/NFe/ImprimirCCe', json)
      .then((resp) => {
        window.open(resp.data.urlPdf);
      })
      .catch((err) => {
        console.log(err);
      });

  };

  return <>

    <div className="container-fluid">
      <div className="row flex-nowrap">
        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>
        <div className="row">
          <div className="col-md-10 py-3">
            <div className="card">
              <div className="card-body">
                <h4 className="text-muted mb-3">NFe - Entradas</h4>

                {/* Filtro */}
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                        aria-expanded="false" aria-controls="collapseOne">
                        Filtro
                      </button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <div className="row mb-3">
                          <div className="col-sm-3">
                            <label for="selectStatus" className="text-secondary">Status</label>
                            <select className="form-select" name="status_select" id="selectStatus" onChange={ChangeStatus}>
                              <option value="">Todos os status</option>
                              {
                                status.map((item) => {
                                  return <option key={item.id} value={item.id}>{item.nome}</option>
                                })
                              }
                            </select>
                          </div>
                          <div className="col-sm-3">
                            <label for="selectManifesto" className="text-secondary">Manifesto</label>
                            <select className="form-select" name="status_select" id="selectManifesto" onChange={ChangeManifesto}>
                              <option value="">Todos os Manifestos</option>
                              {
                                manifestos.map((item) => {
                                  return <option key={item.id} value={item.id}>{item.nome}</option>
                                })
                              }
                            </select>
                          </div>
                          <div className="col-sm-6">
                            <label className="text-secondary">Fornecedor</label>
                            <input type="text" className="form-control" onChange={(e) => setNomeDestina(e.target.value)} value={nomeDestina} />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="col-sm-2">
                            <label className="text-secondary">A partir da emissão</label>
                            <input type="date" className="form-control" onChange={(e) => setDataDe(e.target.value)} value={dataDe} />
                          </div>
                          <div className="col-sm-2">
                            <label className="text-secondary">Até a emissão</label>
                            <input type="date" className="form-control" onChange={(e) => setDataAte(e.target.value)} value={dataAte} />

                          </div>
                          <div className="col-sm-2">
                            <label className="text-secondary">Valor</label>
                            <input type="number" className="form-control" onChange={(e) => setValorDe(e.target.value)} value={valorDe} />

                          </div>
                          <div className="col-sm-2">
                            <label className="text-secondary">Nro Nota</label>
                            <input type="text" className="form-control" onChange={(e) => setNumeroNota(e.target.value)} value={numeroNota} />
                          </div>
                          <div className="col-sm-4">
                            <label className="text-secondary">Chave de acesso</label>
                            <input type="text" className="form-control" onChange={(e) => setChave(e.target.value)} value={chave} />
                          </div>
                        </div>

                        <div className="row mb-3">
                          <div className="btn-opcoes col-md-12" style={{ textAlign: 'right' }}>
                            <button type="button" className="btn btn-outline-secondary" style={{ marginRight: 8 }}
                              onClick={() => limparFiltro()}>
                              <FiRefreshCcw /><span> Limpar filtro </span>
                            </button>
                            <button type="button" className="btn btn-primary float-end mr-4"
                              onClick={() => Listar()}>
                              <FiFilter /><span> Filtrar </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Botões */}
                <br></br>
                <div className="row">
                  <div className="btn-opcoes col-md-12" style={{ textAlign: 'right' }}>
                    <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                      <button className="btn btn-primary me-2" onClick={() => Consultar()}>
                        <FiDownload /><span> </span>
                        Consultar
                      </button>

                      <button id="btnGroupDrop1" type="button" className="btn btn-primary  me-2" data-bs-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        Manifestar
                      </button>
                      <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a onClick={() => Ciencia()} className="dropdown-item"
                          title="Efetua a Ciência da operação e habilita o arquivamento da nota." href="#">Ciência</a>
                        <a onClick={() => Confirmar()} className="dropdown-item"
                          title="Confirma a operação da nota." href="#">Confirmar</a>
                        <a onClick={() => Desconhecer()} className="dropdown-item"
                          title="Manifesta o desconhecimento da operação." href="#">Desconhecer</a>
                        <a onClick={() => NaoRealizar()} className="dropdown-item"
                          title="Manifesta a não realização da operação." href="#">Não realizada</a>
                      </div>
                      <button className="btn btn-primary me-2" onClick={() => modalChave()}>
                        <FiDownload /><span> </span>
                        Consulta por chave
                      </button>
                    </div>
                  </div>
                </div>

                {/* <ModalSefaz /> */}
                <Modal show={showModalSefaz} onHide={closeModalSefaz}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                      <div>
                        Conexão com a Sefaz em andamento...
                        <Spinner animation="border" variant="primary" />
                      </div>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Fique à vontadade para utilizar o sistema enquanto consultamos suas notas.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={closeModalSefaz}>
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* Mais Informações */}
                <Modal
                  show={showModalMaisInfo} onHide={closeModalMaisInfo}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Mais informações
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <div className='row mb-3'>
                        <Form.Group className="col-sm-1">
                          <Form.Label>#ID:</Form.Label>
                          <p>{infoID}</p>
                          {/* <Form.Text className="text-muted"> {infoID}</Form.Text> */}
                        </Form.Group>

                        <Form.Group className="col-sm-6">
                          <Form.Label>Chave de acesso: </Form.Label>
                          <p>{infoChave}</p>
                        </Form.Group>

                        <Form.Group className="col-sm-5">
                          <Form.Label>Destinatário: </Form.Label>
                          <p> {infoDestina}</p>
                        </Form.Group>
                      </div>
                    </Form>
                    <div className='row'>
                      <DataTable className="dataTables_wrapper"
                        columns={colEventos}
                        data={dadosEventos}
                        noDataComponent={<p className="no-data-found">Nenhum evento encontrado</p>}
                        pagination={false}
                        highlightOnHover
                        pointerOnHover
                        dense
                      />
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button onClick={closeModalMaisInfo}>Fechar</Button>
                  </Modal.Footer>
                </Modal>

                {/* Consulta Chave de acesso */}
                <Modal
                  show={showModalChave} onHide={closeModalChave}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Consulta chave
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Form.Group className="mb-3" controlId="chNFe">
                        <Form.Label>Chave de acesso</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Chave de acesso da NF-e"
                          autoFocus
                          onChange={(e) => setChNFe(e.target.value)} value={chNFe}
                        />
                      </Form.Group>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <button type="button" className="btn btn-outline-secondary float-end mr-4"
                      onClick={closeModalChave}>
                      Fechar
                    </button>
                    <Button ovariant="primary" onClick={ConsultarChave}>Consultar</Button>
                  </Modal.Footer>
                </Modal>

                {/* Justificativa para o Manifesto de Não Realizada */}
                <Modal
                  show={showModalJustificativa} onHide={closeModalJustificativa}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Justificativa
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Form.Group className="mb-3" controlId="chNFe">
                        {/* <Form.Label>Justificativa</Form.Label> */}
                        <Form.Control
                          as="textarea"
                          type="text"
                          placeholder="Informe aqui o motivo do Manifesto para Operação Não realizada."
                          autoFocus
                          onChange={(e) => setJustificativa(e.target.value)} value={justificativa}
                        />
                      </Form.Group>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <button type="button" className="btn btn-outline-secondary float-end mr-4"
                      onClick={closeModalJustificativa}>
                      Fechar
                    </button>
                    <Button ovariant="primary" onClick={ManifestarNaoRealizada}>Manifestar</Button>
                  </Modal.Footer>
                </Modal>

                {/* Tabela */}
                <br></br>
                {/* <DataTable className="table-responsive" */}
                  <DataTable
                    keyField="id"
                    columns={columns}
                    data={dados}
                    pagination={true}
                    paginationComponentOptions={paginationOptions}
                    noDataComponent={loading ? <Spinner animation="border" variant="primary" /> :
                      <p className="no-data-found">Nenhum registro encontrado</p>
                    }
                    paginationServer={true}
                    paginationTotalRows={totalRegistros}
                    highlightOnHover
                    pointerOnHover
                    selectableRows
                    selectableRowsHighlight
                    selectableRowsNoSelectAll

                    // selectableRows={false}
                    dense
                    onChangeRowsPerPage={ChangePerRows}
                    onChangePage={ChangePage}
                    onSelectedRowsChange={handleSelectedRowsChange}

                  />


                {/* Resultado da consulta   */}
                <Modal show={showModaResultadoConsulta} onHide={closeModalResultadoConsulta}
                  size="xl"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Resultado da consulta
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className='row'>
                      <Card
                        bg={'Success'.toLowerCase()}
                        key={'Success'}
                        text={'Success'.toLowerCase() === 'light' ? 'dark' : 'white'}
                        style={{ width: '23rem', fontSize: 20 }}
                        className="mb-2 text-center"
                      >

                        <Card.Header>Notas fiscais</Card.Header>
                        <Card.Body>

                          <Card.Text style={{ fontSize: 55 }}>
                            {qtdNota}
                          </Card.Text>
                        </Card.Body>
                      </Card>

                      <Card
                        bg={'Primary'.toLowerCase()}
                        key={'Primary'}
                        text={'Primary'.toLowerCase() === 'light' ? 'dark' : 'white'}
                        style={{ width: '23rem', fontSize: 20 }}
                        className="mb-2 text-center"
                      >

                        <Card.Header>Carta de Correção</Card.Header>
                        <Card.Body>

                          <Card.Text style={{ fontSize: 55 }}>
                            {qtdCCe}
                          </Card.Text>
                        </Card.Body>
                      </Card>

                      <Card
                        bg={'Danger'.toLowerCase()}
                        key={'Danger'}
                        text={'Danger'.toLowerCase() === 'light' ? 'dark' : 'white'}
                        style={{ width: '23rem', fontSize: 20 }}
                        className="mb-2 text-center"
                      >

                        <Card.Header>Canceladas</Card.Header>
                        <Card.Body>

                          <Card.Text style={{ fontSize: 55 }}>
                            {qtdCancelada}
                          </Card.Text>
                        </Card.Body>
                      </Card>
                    </div>

                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={closeModalResultadoConsulta}>
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* Resultado do Manifesto   */}
                <Modal show={showModaResultadoManifesto} onHide={closeModalResultadoManifesto}
                  size="xl"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Resultado do manifesto
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <DataTable className="dataTables_wrapper"
                      columns={colManifesto}
                      data={dadosManifesto}
                      pagination={false}
                      highlightOnHover
                      pointerOnHover
                      dense
                    />

                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={closeModalResultadoManifesto}>
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </>
};



export default NFeEntrada;